import { ReactNode } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { useStyles } from './discount-banner.styles';
import { InternalLinks } from '../../../../../../constants';


export const DiscountBanner = (): JSX.Element => {
  const intl = useIntl();
  const classes = useStyles();

  return (
    <div
      className={classes.root}
      data-testid="discount-banner"
    >
      <h3 className={classes.title}>
        <FormattedMessage
          id="myLensesDetailed.notFitted.banner.title"
        />
      </h3>
      <div className={classes.description}>
        {intl.formatMessage(
          { id: 'myLensesDetailed.notFitted.description' },
          {
            p: (chunk: ReactNode) => <p className={classes.descriptionParagraph}>{chunk}</p>,
            sup: (chunks: ReactNode) => <sup>{chunks}</sup>,
            link: (chunk: ReactNode) => (
              <a
                data-testid="ecp-link"
                className={classes.ecpLink}
                href={InternalLinks.ecpLocator}
              >
                {chunk}
              </a>
            ),
          },
        )}
      </div>
    </div>
  );
};
